import { isMobileBrowser } from '@rover/utilities/device';
import { getRouteURL } from '@rover/utilities/deeplink';

import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';
import dataLayer from '@rover/globals/dataLayer';
import { isAndroid, isMobileEmbedded } from '@rover/utilities/userAgent';
import i18n from '@rover/utilities/translation';
import { t } from '@lingui/macro';

export default class {
  static closeBanner() {
    $('.js-app-banner').addClass('hidden');
    $('body').removeClass('has-banner');
    $.cookie('appBanner', true, { expires: 90 });
  }

  static fireClickEvent() {
    dataLayer.push({
      event: 'mobile-web-app-download-install',
    });
  }

  static isPossibleBanner() {
    return !$.cookie('appBanner');
  }

  static init() {
    if (
      !isMobileBrowser() ||
      !this.isPossibleBanner() ||
      isMobileEmbedded() ||
      $('body').hasClass('no-banner') ||
      !Rover.context.supportsMobileApp
    ) {
      return;
    }

    const appInstallBannerShownEvent = {
      event: 'navigation-app-install-banner-shown',
      nonInteractive: true,
    };

    const reviewsText = i18n._(t`Reviews`);
    Rover.context.iOSReviewCount = `76.8k+ ${reviewsText}`;
    Rover.context.androidReviewCount = `4,300+ ${reviewsText}`;

    dataLayer.push({ ...appInstallBannerShownEvent });

    const routeURL = getRouteURL();

    $('body').addClass('has-banner');
    $('.js-app-banner').removeClass('hidden');
    $('.js-app-install-link').attr('href', routeURL);
    $('.js-app-install-link').on('click', this.fireClickEvent);

    $('.js-close-app-banner').on('click', this.closeBanner);
    if (isAndroid()) {
      $('.js-review-count').text(Rover.context.androidReviewCount);
    } else {
      $('.js-review-count').text(Rover.context.iOSReviewCount);
    }
  }
}



// WEBPACK FOOTER //
// ./js/AppInstallBanner.js